import { EnumCustomFilterTypes } from '@m4u-angular/core/framework/sysenums.enum';
import { Column } from 'devextreme/ui/data_grid';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { Directive, Input } from '@angular/core';


@Directive({ selector: 'dxi-column[configServerSideCustomFilter]' })
export class M4UConfigServerSideCustomFilterDirective {
    @Input() CustomFilterType: EnumCustomFilterTypes;

    constructor(column: DxiColumnComponent) {
        column.calculateFilterExpression = this.getCalculateFilterExpression();
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    getCalculateFilterExpression(): Function {
        switch (this.CustomFilterType) {
            case EnumCustomFilterTypes.RelatedToAtLeastOne:
                return this.RelatedToAtLeastOneFilterExpressionBuilder;
            default: return this.RelatedToAtLeastOneFilterExpressionBuilder;
        }
    }

    RelatedToAtLeastOneFilterExpressionBuilder(this: Column, filterValue: any, selectedFilterOperation: string, target) {
        return [this.dataField, <string>EnumCustomFilterTypes.RelatedToAtLeastOne, filterValue];
    }
}
